import { premiumBuildingsPrices } from "@/config/constants";
import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { ceilNumber } from "@/utils/number";
import { FrameName } from "../config";
import { getStorageResourceMultiplier } from "../config/buildings";
import type { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";
class UniversalWarehouseBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.UNIVERSAL_WAREHOUSE;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];

	public get storage(): Map<ResourceType, number> {
		const storage = new Map<ResourceType, number>(super.storage);

		// Apply upgrades for each resource in the storage map.
		for (const resource of storage.keys()) {
			let resourceStorage = (storage.get(resource) as number) || 0;
			resourceStorage *=
				1 +
				getUpgradeCurrentReplaceValueById(UpgradeIds.premium_storage) +
				getStorageResourceMultiplier(
					this.getOwnNeighbourTileEntitiesByNeighbourFrameName(
						FrameName.STORAGE_OVERSEER,
						1,
					),
				);
			resourceStorage = ceilNumber(resourceStorage);
			storage.set(resource, resourceStorage);
		}

		return storage;
	}
}

export default UniversalWarehouseBuildingTileEntity;
